export { default as useTranslation } from './useTranslation';
